<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close #closeButton>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content >
    <div class="row" *ngIf="bookingsData.length>0">
        <div class="col-sm-4" *ngFor="let item of bookingsData">
            <div class="fl_orders" (click)="selectBooking(item)">
                <div class="top_section_order">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="ads_sec">
                                <div class="hm_icon_progr" style="    width: 50px;
                                text-align: center;
                                height: 50px;
                                font-size: 2.5rem;
                                padding-top: 15px;
                                background: #fdd65e;
                                border-radius: 50px;">
                                    {{item.appointment_no}}
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="order_dec">
                              
                                <div class="tick_opklads" [ngStyle]="{'background': item.selected ? '#1da942' : 'lightgrey'}" >
                                    <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
                                    <mat-icon class="material-icons-outlined" class="mb-1" style="color: #fff;">check</mat-icon
            >
                                </div>
                                <h3 style="-webkit-box-orient: vertical;
                                display: -webkit-box;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: normal;
                                ">{{item.customer_name}}</h3>
                                <p *ngIf="item.servicesArray && item.servicesArray != ''">{{
                                  item.servicesArray.length > 25
                                    ? item.servicesArray.substring(0, 25) + "..."
                                    : item.servicesArray
                                }}
                                </p>
                                <p *ngIf="!item.servicesArray || item.servicesArray == ''">No services added
                                </p>
                                <p>{{item.customer_phone}}
                                </p>
                                <p>Status: <span style="font-weight: bold; color: #000;">{{item.bookingStat}}</span>  
                                </p>
                                <!-- <p class="pricecls">Price: <b>Rs.</b> </p> -->
                                <!-- <input type="text" [(ngModel)]="item.price" [disabled]="item.isDisabled == true"> -->
                             </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        
        

    </div>
    <div class="row" *ngIf="bookingsData.length == 0 && !loading">
      <div style="padding: 50px 0px; text-align: center;">
        <h2>No bookings to show</h2>
      </div>
    </div>
    <div class="row" *ngIf="loading">
      <div style="padding: 50px 0px; text-align: center;">
        <h2>Please wait while we load the bookings.</h2>
      </div>
    </div>
  </mat-dialog-content>


  <mat-dialog-actions align="end" >
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      [disabled]="
      selectedBookingList.length == 0

      "
      mat-flat-button
      color="accent"
      (click)="onSelectNext()"
    >
      Confirm
    </button>
  </mat-dialog-actions>
  